import loadable from 'components/dynamic-import';

export const PublicOriginalPage = loadable(() => import('./PublicOriginalsPage'));
